<template>
  <div id="program">
    <app-navbar />

    <div class="redWrap">
      <img v-parallax="0.2" class="img-fluid" src="@/assets/designelements/redWrap.png" alt="redWrap">
    </div>
    <div class="redBalloneHalf">
      <img v-parallax="0.1" class="img-fluid" src="@/assets/designelements/redBalloneHalf.png" alt="redBalloneHalf">
    </div>

    <div class="container program-block">
      <h1 class="text-center">{{ "Program.title" | staticTranslation }}</h1>
      <h4 class="program-intro text-center pb-lg-5 pt-5" v-html="htmlTextEntrance"></h4>

      <ProgramFilters
        :stages="stages"
        :genres="genres"
        :selectedStageId.sync="selectedStageId"
        :selectedGenreId.sync="selectedGenreId"
      />

      <div class="programList">
        <ProgramDay
          v-for="day in filteredPeriod.days"
          :key="$options.filters.dateId(day.date)"
          :day="day"
          :default-open="isDayCurrentOrUpcoming(day.date)"
        />
      </div>
    </div>

    <app-footer />
  </div>
</template>

<script>
import navbar from "@/components/base/navbar";
import footer from "@/components/base/footer";
import axios from "@/api/axiom-instance";
import moment from "moment";

import ProgramFilters from "@/components/base/program/mainProgram/ProgramFilters.vue";
import ProgramDay from "@/components/base/program/mainProgram/ProgramDay.vue";

export default {
  name: "Program",
  components: {
    "app-navbar": navbar,
    "app-footer": footer,
    ProgramFilters,
    ProgramDay
  },
  data() {
    return {
      period: { days: [] },
      genres: [],
      stages: [],
      selectedStageId: null,
      selectedGenreId: null
    };
  },
  computed: {
    htmlTextEntrance() {
      return this.$options.filters.staticTranslation("Program.textEntrance");
    },

    filteredPeriod() {
      const days = Array.isArray(this.period?.days) ? this.period.days : [];

      const filteredDays = days
        .map(day => {
          const stages = (day.stages || [])
            .filter(stage => !this.selectedStageId || stage.id === this.selectedStageId)
            .map(stage => {
              const events = (stage.events || []).filter(event => {
                if (!this.selectedGenreId) return true;
                return (event.interprets || []).some(i =>
                  (i.genres || []).some(g => g.id === this.selectedGenreId)
                );
              });
              return { ...stage, events };
            })
            .filter(stage => stage.events && stage.events.length > 0);

          return { ...day, stages };
        })
        .filter(day => day.stages && day.stages.length > 0);

      return { ...this.period, days: filteredDays };
    }
  },
  created() {
    axios.get("/period/actual").then(({ data }) => {
      this.period = data || { days: [] };
    }).catch(console.log);

    axios.get("/stage/list/actual").then(({ data }) => {
      this.stages = data || [];
      this.applyStageFromQuery();
    }).catch(console.log);

    axios.get("/genre/list/actual").then(({ data }) => {
      this.genres = data || [];
    }).catch(console.log);
  },
  methods: {
    isDayCurrentOrUpcoming(date) {
      return moment(date).isSameOrAfter(moment(), "day");
    },
    applyStageFromQuery() {
      const id = Number(this.$route.query.stage);
      // Localities list every visible stage, but only stages with events in the
      // actual period can be filtered on - ignore the rest and show all.
      if (this.stages.some(stage => stage.id === id)) {
        this.selectedStageId = id;
      }
    }
  }
};
</script>

<style scoped>
/* Necháme jen stránkový “obal”. Karty řeší děti. */
#program {
  background-color: #FFCE6D;
  min-height: 100vh;
}

.program-block {
  padding-bottom: 10em;
  min-height: 120vh;
}

h1 {
  font-size: 2.6em;
  padding-top: 3em;
  padding-bottom: 1.7em;
  font-family: "Transcript Pro";
}

h4 {
  color: black;
  font-size: 1.4em;
  font-family: "Transcript Pro";
}

.program-intro >>> a,
.program-intro >>> a:visited {
  color: #ED5B2D;
}

.program-intro >>> a:hover,
.program-intro >>> a:focus {
  color: #C94720;
}

.redBalloneHalf {
  position: absolute;
  text-align: end;
  right: 0;
  width: 10%;
  top: 80%;
}

.redWrap {
  width: 8%;
  position: absolute;
  top: 20%;
  left: 8%;
}
</style>
